import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

import FormikControl from "components/FormikControl/FormikControl.js";
import { useAuth } from "views/Authentication/AuthContext";
import { Button } from "@material-ui/core";
import useStyles from "views/Styles/LoginStyles";
import { UPDATE_PASSWORD_URL, STORAGE_CONSTANT, URLS } from "configs/constants";
import eightAxios from "configs/axiosConfig";
import { getRedirectUrl } from "utils";
import { useTranslation } from "react-i18next";
import FGVLogo from "../../assets/img/fgv-logo.png";
import { useNotifyContext } from "@Components/Notify";


const UserChangePassword = () => {
  const [redirect, setRedirect] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    authLoading,
    errorMessage,
    logout,
    setErrorMessage,
    setAuthLoading,
  } = useAuth();

  let initialValues = {
    passwordOld: "",
    password: "",
    password1: "",
  };

  const handleBackClick = () => {
    setRedirect(true);
  };
  const setNotify = useNotifyContext();


  const onSubmit = (values) => {
    if (values.password.length && values.password1.length) {
      if (values.password !== values.password1) {
        setErrorMessage("New Passwords do not match!");
      } else {
        setErrorMessage("");
        setAuthLoading(true);
        let credentials = new FormData();
        credentials.append("old_password", values.passwordOld);
        credentials.append("new_password", values.password1);
        eightAxios
          .post(
            UPDATE_PASSWORD_URL +
              localStorage.getItem(STORAGE_CONSTANT.ID) +
              "/",
            credentials
          )
          .then((response) => {
            if (response.status === 200) {
              // setAuthLoading(false);
              setNotify({
                isOpen: true,
                message: response.data.message,
                type: "success",
              });
              setTimeout(function () {
                logout(true);
              }, 2000);

            }
          })
          .catch((error) => {
            if (error.response) {
              let errMsg = "";
              for (let key in error.response.data) {
                errMsg += error.response.data[key] + "\n";
                setErrorMessage(errMsg);
                break;
              }
            } else {
              setErrorMessage(error.message);
            }
            setAuthLoading(false);
          });
      }
    }
  };

  const validationSchema = Yup.object({
    passwordOld: Yup.string().required("Old Password"),
    password: Yup.string().required("New Password"),
    password1: Yup.string().required("Re-enter New Password"),
  });

  if (redirect) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl) return <Redirect to={redirectUrl} />;
    // return <Redirect to="/" />;
  } else {
    return (
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {!authLoading
          ? (formik) => {
              return (
                <Form style={{ width: "100%" }}>
                  <Grid
                    className={classes.root}
                    container
                    spacing={2}
                    direction="column"
                    alignItems="center"
                    justify="center"
                  >
                    <Grid item xs={10} sm={6} lg={3}>
                      <img src={FGVLogo} alt="FGV" width={200} />
                    </Grid>
                    <Grid item xs={10} sm={6} lg={3}>
                      <Typography variant="h4">
                        {t("Change Password")}
                      </Typography>
                    </Grid>

                    <Grid className={classes.grid} item xs={10} sm={6} lg={3}>
                      <FormikControl
                        control="restricted"
                        regex={/[^ ]/i}
                        variant="outlined"
                        label={t("Old Password")}
                        labelClasses={classes.labelStyles}
                        name="passwordOld"
                        fullWidth
                        size="small"
                        password
                      />
                      <FormikControl
                        control="restricted"
                        regex={/[^ ]/i}
                        variant="outlined"
                        label={t("New Password")}
                        labelClasses={classes.labelStyles}
                        name="password"
                        fullWidth
                        size="small"
                        password
                      />
                      <FormikControl
                        control="restricted"
                        regex={/[^ ]/i}
                        labelClasses={classes.labelStyles}
                        variant="outlined"
                        label={t("Re-Enter New Password")}
                        name="password1"
                        fullWidth
                        size="small"
                        password
                      />
                      <Grid item>
                        <Typography
                          align="center"
                          variant="subtitle1"
                          color="error"
                        >
                          {errorMessage}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        style={{ paddingTop: "10px" }}
                      >
                        <Grid item>
                          <Button
                            type="submit"
                            disabled={!formik.isValid || authLoading}
                            variant="contained"
                            color="primary"
                          >
                            {t("Submit")}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            type="cancel"
                            variant="contained"
                            color="primary"
                            onClick={handleBackClick}
                          >
                            {t("Cancel")}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              );
            }
          : null}
      </Formik>
    );
  }
  return (
    <Redirect
      to={{
        pathname: URLS.LOGIN,
      }}
    />
  );
};

UserChangePassword.propTypes = {
  location: PropTypes.object,
};
export default UserChangePassword;
